import { DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI } from '../../default-cloud-graph-remote-link-entity-ati';
import { NounSubtypeKey, TypeFilterValueKey } from '../../filters/universal-type';
import { get3PLogo } from '../../icons';
import { type ThirdPartyConfig } from '../../schemas/3p-config';

import { AmplitudeIcon } from './icon';
import { AmplitudeSearchResultIcon } from './search-result-icon';

export const amplitudeConfig: ThirdPartyConfig = {
	displayName: 'Amplitude',
	id: 'amplitude',
	resourceType: 'smartlinks-connector-amplitude',
	icon: get3PLogo(AmplitudeIcon, 'Amplitude', 'medium'),
	searchResultIcon: get3PLogo(AmplitudeSearchResultIcon, 'Amplitude', 'large'),
	integrationAri: 'ari:cloud:platform::integration/amplitude',
	typeFilterConfig: new Map([
		[
			TypeFilterValueKey.Dashboard,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI,
				subTypes3P: [NounSubtypeKey.Dashboard],
			},
		],
	]),
	requiresOauth: true,
	isEnabled: () => true,
};
